var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("g", { staticClass: "SelectorG", class: _setup.statusClass() }, [
    _c(
      "rect",
      _vm._b(
        {
          staticClass: "cabin",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _setup.detail_click.apply(null, arguments)
            },
          },
        },
        "rect",
        _setup.props.cabAttrs,
        false
      )
    ),
    _vm._v(" "),
    _c(
      "text",
      _vm._b(
        {
          staticClass: "cabin_num",
          domProps: { textContent: _vm._s(_setup.props.numAttrs.text) },
        },
        "text",
        _setup.props.numAttrs,
        false
      )
    ),
    _vm._v(" "),
    _c(
      "text",
      _vm._b(
        { staticClass: "cabin_vacancies" },
        "text",
        _setup.props.vacAttrs,
        false
      ),
      [
        _vm._v(
          _vm._s(
            _setup.isBooked() ? _setup.gostey(_setup.occupation) : _setup.mest()
          )
        ),
      ]
    ),
    _vm._v(" "),
    _setup.isFree(_setup.props.Cabin)
      ? _c(
          "foreignObject",
          { attrs: { width: "1", height: "1" } },
          [
            _c(_setup.RoomModal, {
              attrs: {
                Cabin: _setup.props.Cabin,
                CabinSet: _setup.props.CabinSet,
                modalShown: _setup.isModalShown,
              },
              on: { input: _setup.set_isModalShown },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }